import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  Button,
  CheckBox,
  FilterColor,
  FormCheck,
  FormHeader,
  InputBox,
  InputItem,
  MenuItem,
  NewsCard,
  RadioBtnBox,
  RadioButton,
  SectionHeader,
} from "../../components";
import Scrollbars from "react-custom-scrollbars-2";
import { CheckValidity } from "../../utils/formValidity";

const DesignSystemComponent = (props) => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [isSelect, setIsSelect] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [education, setEducation] = useState("");
  const [expertise, setExpertise] = useState("");
  const [availability, setAvailability] = useState("");
  const [formData, setFormData] = useState({
    firstName: {
      key: "firstName",
      label: "First Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Label",
      },
      //isCountryCode: true,
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    fullName: {
      key: "fullName",
      label: "Full Name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Full Name",
      },
      //isCountryCode: true,
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    emailAddress: {
      key: "emailAddress",
      label: "Email Address",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "example@email.com",
      },
      //isCountryCode: true,
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    phoneNumber: {
      key: "phoneNumber",
      label: "Phone Number",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "",
      },
      isCountryCode: true,
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    location: {
      key: "location",
      label: "Location",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "",
      },

      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    preferredLanguage: {
      key: "preferredLanguage",
      label: "Preferred Language of Communication",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "",
      },

      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  //scrollbar start

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const handleChange = async (event, inputIdentity) => {
    const updateNewProductForm = {
      ...formData,
    };

    updateNewProductForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewProductForm[inputIdentity].value,
      updateNewProductForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewProductForm[inputIdentity].isValid = validityRes.isValid;
      updateNewProductForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewProductForm[inputIdentity].value = event;
      updateNewProductForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewProductForm) {
        formIsValid =
          updateNewProductForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewProductForm);
    }
  };

  //update input validation
  const updateInputValidationErrors = async () => {
    let df = { ...formData };
    let formIsValid = true;
    for (let itemKey of Object.keys(df)) {
      if (itemKey === "firstName" || itemKey === "firstName") {
        if (df[itemKey].value === "" || df[itemKey].invalidReason) {
          df[itemKey].touched = true;
          formIsValid = false;
        }
      }
    }
    await setFormData(df);
    return formIsValid;
  };

  // const dispatch = useDispatch();
  const updateNewProductForm = { ...formData };

  return (
    <>
      <div className={`design-guide-main-wrapper d-flex`}>
        <h2>Design System</h2>
        <div className={"design-system-wrapper"}>
          <div>
            <RadioButton
              data={{ name: "High School", isActive: isActive }}
              onClick={() => {
                if (isActive) {
                  setIsActive(false);
                } else {
                  setIsActive(true);
                }
              }}
            />
          </div>
          {/* <div>
            <RadioButton data={{ name: "High School", isActive: true }} />
          </div> */}
          <InputBox
            data={updateNewProductForm.firstName}
            onChange={async (e) => {
              e.preventDefault();
              await handleChange(
                e.target.value,
                updateNewProductForm.firstName.key
              );
            }}
          />
          {/* <FormCheck
            data={{
              isSelect: true,
              iconName: "check",
            }}
          /> */}
          <FormCheck
            data={{
              isSelect: isSelect,
              iconName: "check",
            }}
            onClick={() => {
              if (isSelect) {
                setIsSelect(false);
              } else {
                setIsSelect(true);
              }
            }}
          />
          <CheckBox
            data={{ checkName: "High School", isActive: isSelect }}
            onClick={() => {
              if (isSelect) {
                setIsSelect(false);
              } else {
                setIsSelect(true);
              }
            }}
          />
          {/* <CheckBox data={{ checkName: "High School", isActive: true }} /> */}

          <Button
            data={{
              btnName: "Join Us",
              buttonType: "primary",
              buttonSize: "lg",
              isLoading: false,
            }}
            // onClick={ () => {}}
          />
          <Button
            data={{
              btnName: "Join Us",
              buttonType: "primary loading",
              buttonSize: "lg",
              isLoading: true,
            }}
            // onClick={ () => {}}
          />
          <Button
            data={{
              btnName: "Join Us",
              buttonType: "primary disabled",
              buttonSize: "lg",
              isLoading: false,
            }}
            // onClick={ () => {}}
          />
          <Button
            data={{
              btnName: "Join Us",
              buttonType: "secondary",
              buttonSize: "lg",
              isLoading: false,
            }}
            // onClick={ () => {}}
          />
          <Button
            data={{
              btnName: "Join Us",
              buttonType: "secondary disabled",
              buttonSize: "lg",
              isLoading: false,
            }}
            // onClick={ () => {}}
          />
          <Button
            data={{
              btnName: "Join Us",
              buttonType: "secondary loading",
              buttonSize: "lg",
              isLoading: true,
            }}
            // onClick={ () => {}}
          />
          {/* <FormHeader
            data={{
              formHeader: "JOIN US",
              size: "lg",
            }}
          />
          {/* <SectionHeader data={{ title: "Basic Information", size: "sm" }} /> */}
          {/* <FormHeader
            data={{
              formHeader:
                "Special English & IT Study Program - Volunteer/Donator Registration Form",
              size: "sm",
            }}
          />
          <SectionHeader data={{ title: "Basic Information", size: "sm" }} /> */}
        </div>
        {/* /////////////////////////////////////////////////////// */}
        <div className={"join-us-form-wrapper"}>
          <FormHeader
            data={{
              formHeader: "JOIN US",
              size: "lg",
            }}
          />
          <FormHeader
            data={{
              formHeader:
                "Special English & IT Study Program - Volunteer/Donator Registration Form",
              size: "sm",
            }}
          />

          <SectionHeader data={{ title: "Basic Information", size: "sm" }} />

          <InputBox
            data={updateNewProductForm.fullName}
            onChange={async (e) => {
              e.preventDefault();
              await handleChange(
                e.target.value,
                updateNewProductForm.fullName.key
              );
            }}
          />
          <div className="information-wrapper">
            <InputBox
              data={updateNewProductForm.emailAddress}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.emailAddress.key
                );
              }}
            />
            <InputBox
              data={updateNewProductForm.phoneNumber}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.phoneNumber.key
                );
              }}
            />
          </div>
          <div className="information-wrapper">
            <InputBox
              data={updateNewProductForm.location}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.location.key
                );
              }}
            />
            <InputBox
              data={updateNewProductForm.preferredLanguage}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(
                  e.target.value,
                  updateNewProductForm.preferredLanguage.key
                );
              }}
            />
          </div>
          <SectionHeader
            data={{ title: "Educational Background", size: "sm" }}
          />
          <div className="information-wrapper">
            <RadioButton
              data={{
                name: "High School",
                isActive: education === "High School",
              }}
              onClick={() => {
                if (education) {
                  setEducation("");
                } else {
                  setEducation("High School");
                }
              }}
            />
            <RadioButton
              data={{ name: "Diploma", isActive: education === "Diploma" }}
              onClick={() => {
                if (education) {
                  setEducation("");
                } else {
                  setEducation("Diploma");
                }
              }}
            />
            <RadioButton
              data={{ name: "Degree", isActive: education === "Degree" }}
              onClick={() => {
                if (education) {
                  setEducation("");
                } else {
                  setEducation("Degree");
                }
              }}
            />
            <RadioButton
              data={{ name: "Other", isActive: education === "Other" }}
              onClick={() => {
                if (education) {
                  setEducation("");
                } else {
                  setEducation("Other");
                }
              }}
            />
          </div>
          <SectionHeader data={{ title: "Area of Expertise", size: "sm" }} />
          <div className="information-wrapper">
            <RadioButton
              data={{
                name: "English Language Teaching",
                isActive: expertise === "English Language Teaching",
              }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("English Language Teaching");
                }
              }}
            />
            <RadioButton
              data={{
                name: "IT Skills (Basic)",
                isActive: expertise === "IT Skills (Basic)",
              }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("IT Skills (Basic)");
                }
              }}
            />
            <RadioButton
              data={{
                name: "IT Skills (Advanced)",
                isActive: expertise === "IT Skills (Advanced)",
              }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("IT Skills (Advanced)");
                }
              }}
            />
          </div>
          <div className="information-wrapper">
            <RadioButton
              data={{
                name: "Programming",
                isActive: expertise === "Programming",
              }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("Programming");
                }
              }}
            />
            <RadioButton
              data={{
                name: "Web Development",
                isActive: expertise === "Web Development",
              }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("Web Development");
                }
              }}
            />
            <RadioButton
              data={{
                name: "Database Management",
                isActive: expertise === "Database Management",
              }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("Database Management");
                }
              }}
            />
          </div>
          <div className="information-wrapper">
            <RadioButton
              data={{
                name: "Mobile app",
                isActive: expertise === "Mobile app",
              }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("Mobile app");
                }
              }}
            />
            <RadioButton
              data={{ name: "UI/UX", isActive: expertise === "UI/UX" }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("UI/UX");
                }
              }}
            />
            <RadioButton
              data={{
                name: "Cloud Security",
                isActive: expertise === "Cloud Security",
              }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("Cloud Security");
                }
              }}
            />
            <RadioButton
              data={{ name: "Other", isActive: expertise === "Other" }}
              onClick={() => {
                if (expertise) {
                  setExpertise("");
                } else {
                  setExpertise("Other");
                }
              }}
            />
          </div>
          <SectionHeader data={{ title: "Availability", size: "sm" }} />
          <div className="information-wrapper">
            <RadioButton
              data={{
                name: "Full-time",
                isActive: availability === "Full-time",
              }}
              onClick={() => {
                if (availability) {
                  setAvailability("");
                } else {
                  setAvailability("Full-time");
                }
              }}
            />
            <RadioButton
              data={{
                name: "Part-time",
                isActive: availability === "Part-time",
              }}
              onClick={() => {
                if (availability) {
                  setAvailability("");
                } else {
                  setAvailability("Part-time");
                }
              }}
            />
            <RadioButton
              data={{
                name: "Weekends Only",
                isActive: availability === "Weekends Only",
              }}
              onClick={() => {
                if (availability) {
                  setAvailability("");
                } else {
                  setAvailability("Weekends Only");
                }
              }}
            />
          </div>
          <FormHeader
            data={{
              formHeader:
                "I agree to the volunteer terms and conditions of the Special English & IT Study Program.",
              size: "sm",
            }}
          />
          <Button
            data={{
              btnName: "Join Us",
              buttonType: "primary disabled",
              buttonSize: "lg",
              isLoading: false,
            }}
            // onClick={ () => {}}
          />
        </div>
        <div className={"mt-4"}>
          <NewsCard data={{ type: "small" }} />
          <NewsCard data={{ type: "medium" }} />
          <NewsCard data={{ type: "large" }} />
        </div>
      </div>
    </>
  );
};

export default DesignSystemComponent;
